import { render } from "./orderCard.vue?vue&type=template&id=7c33d0e6&scoped=true"
import script from "./orderCard.vue?vue&type=script&lang=js"
export * from "./orderCard.vue?vue&type=script&lang=js"

import "./orderCard.vue?vue&type=style&index=0&id=7c33d0e6&lang=less&scoped=true"

import exportComponent from "D:\\微客\\we_customer_guide\\node_modules\\_vue-loader@16.8.3@vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c33d0e6"]])

export default __exports__